import React from 'react'

import clsx from 'clsx'

import Logo from 'components/Logo'

import classes from './ProductTag.module.scss'

const ProductTag = ({ listing, className = '' }) => {
  return (
    <div className={clsx(classes.root, className)}>
      <Logo src={listing.logo_url} alt="logo" size={16} className={classes.logo} />
      <span className={classes.text}>{listing.name}</span>
    </div>
  )
}

export default ProductTag
